import type { ReactNode } from "react";

import type { HaNTextRange } from "@lib/logic";

import { HighlightedText } from "./HighlightedText";

type HaNSearchResultCellProps = {
  icon: ReactNode;
  name: string;
  ranges: HaNTextRange[];
  details: string;
};

export const HaNSearchResultCell = ({ icon, name, ranges, details }: HaNSearchResultCellProps) => {
  return (
    <div className="flex min-w-0 items-center gap-3">
      {icon}
      <div className="flex min-w-0 flex-col gap-0.5">
        <p className="truncate font-semibold">
          <HighlightedText
            text={name}
            ranges={ranges}
          />
        </p>
        <p className="truncate text-mapiq-black-500">{details}</p>
      </div>
    </div>
  );
};
